module.exports = __webpack_public_path__ + "static/media/Waterstone-HOA-Bylaws.61c3266e.pdf";